import script from "./sw-item-viewer-url.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-viewer-url.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-viewer-url.vue?vue&type=style&index=0&id=04ad4256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ad4256"]])

export default __exports__